// src/components/HeaderIconButton.tsx
// ヘッダー右側の丸いアイコンボタン。LanguageSwitcher の見た目に揃えている。
import React from 'react';

const BG = 'rgba(255, 255, 255, 0.14)';
const BG_HOVER = 'rgba(255, 255, 255, 0.22)';
const BG_ACTIVE = 'rgba(255, 255, 255, 0.24)';

type HeaderIconButtonProps = {
  label: string;
  active?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
};

export function HeaderIconButton({ label, active = false, onClick, children }: HeaderIconButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      aria-expanded={onClick ? active : undefined}
      title={label}
      onClick={onClick}
      style={{
        width: '30px',
        height: '30px',
        borderRadius: '999px',
        border: '1px solid rgba(255, 255, 255, 0.55)',
        background: active ? BG_ACTIVE : BG,
        color: 'white',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        flexShrink: 0,
        transition: 'background-color 0.2s ease',
      }}
      onMouseEnter={(event) => {
        if (!active) event.currentTarget.style.background = BG_HOVER;
      }}
      onMouseLeave={(event) => {
        if (!active) event.currentTarget.style.background = BG;
      }}
    >
      {children}
    </button>
  );
}
